module.exports = __webpack_public_path__ + "static/media/zm.d9c64562.svg";